import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function MorphingHeadline({ words = [], interval = 2400, className = "" }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setI((p) => (p + 1) % words.length), interval);
    return () => clearInterval(id);
  }, [words, interval]);

  return (
    <span className={`relative inline-flex align-bottom ${className}`}>
      <AnimatePresence mode="wait">
        <motion.span
          key={words[i]}
          initial={{ y: "55%", opacity: 0, filter: "blur(8px)" }}
          animate={{ y: 0, opacity: 1, filter: "blur(0px)" }}
          exit={{ y: "-55%", opacity: 0, filter: "blur(8px)" }}
          transition={{ duration: 0.45, ease: [0.6, -0.05, 0.01, 0.99] }}
          className="text-gradient font-display whitespace-nowrap"
        >
          {words[i]}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
